import { Button } from '@vwfs-bronson/bronson-react';

function compactId(value: string): string {
  return value.length > 18 ? `${value.slice(0, 8)}…${value.slice(-4)}` : value;
}

export function CompactId({ label, value }: { label: string; value: string }) {
  return (
    <span className="app-compact-id" title={value}>
      <code>{compactId(value)}</code>
      <Button
        ariaLabel={`Copy ${label}`}
        className="app-copy-id"
        icon="semantic-file"
        link
        onClick={event => {
          event.stopPropagation();
          void navigator.clipboard?.writeText(value);
        }}
        simple
        small
        title={`Copy full ${label}`}
      />
    </span>
  );
}
